import React from "react";
import MovieSessionSelector from "@components/V3/MovieDetails/MovieSessionSelector";
import MovieTitleCard from "@components/V3/MovieDetails/MovieTitleCard";

const MovieDetailsBase = () => {


    return (
        <>
            <MovieTitleCard />
            <MovieSessionSelector />
        </>
    );
};

export default MovieDetailsBase;
